  <ul [class]='toggleView? "vehicule-permit-admin visible" : "vehicule-permit-admin hidden"' *ngFor='let permit of permits' >
    <li>{{permit.localisation}}   <span>Modifié : {{permit.lastModified}}</span></li>
  </ul>
